export default __webpack_public_path__ + "static/media/payung.ab624bde.svg";